<template>
  <div class="news_details_wrap news-detail-page">
    <PCNavbar selectIndex="4-2"/>
    <MobileNavBar :currentActive="3"/>
    <div class="news_content">
      <el-breadcrumb class="news_bread" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>

      <article class="news_article">
        <header class="news_article_header">
          <h1 class="news_title">
            济南市历城区发展和改革局领导莅临我司参观指导
          </h1>
          <div class="news_meta">
            <span class="news_meta_item">来源：山东智能工业装备公司</span>
            <span class="news_meta_sep">·</span>
            <span class="news_meta_item">投稿时间：2026-05-22</span>
          </div>
        </header>

        <div class="article_body">
          <p class="lead">
            2026年5月22日下午，济南市历城区发展和改革局（以下简称"区发改局"）领导一行莅临山东智能工业装备有限公司开展实地调研与指导工作。公司领导青贵恩、殷海波等热情接待，双方围绕新能源产业创新、企业技术布局及未来发展战略进行了深入友好的交流。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img1"
              alt="区发改局领导莅临公司参观"
            >
            <figcaption class="figure_caption">来访参观</figcaption>
          </figure>

          <h2 class="section_title">一、展厅参观与业务介绍</h2>

          <p class="body_paragraph">
            在公司一楼展厅及办公区域，公司殷海波总与财务李金花老师全程陪同来访领导进行参观。殷海波总向各位领导详细介绍了公司的核心设备与技术实力，考察团重点走访了新能源事业部的工作区域，通过现场讲解与实物展示，直观了解了公司在新能源领域的研发布局与实际应用情况。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img2"
              alt="新能源事业部工作区域参观"
            >
            <figcaption class="figure_caption">新能源事业部参观</figcaption>
          </figure>

          <p class="body_paragraph">
            此外，殷海波还结合公司发展历程、核心专利布局、战略合作伙伴以及多个具有代表性的业务落地案例，向各位领导作了全面汇报，充分展现了公司在行业内的技术积淀与市场影响力。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img3"
              alt="公司业务与发展情况汇报"
            >
            <figcaption class="figure_caption">业务与发展汇报</figcaption>
          </figure>

          <h2 class="section_title">二、座谈交流会</h2>

          <p class="body_paragraph">
            参观结束后，双方移步至二楼会议室召开座谈交流会。公司董事长青贵恩携新能源事业部及软件事业部负责人共同出席。会上，各部门负责人分别汇报了当前的运营现状与业务规划。
          </p>

          <p class="body_paragraph">
            区发改局领导认真听取了汇报，对我司在新能源及软件领域取得的阶段性成果给予了充分肯定，并结合当前宏观政策与产业发展趋势，为公司未来的高质量发展提出了宝贵的指导意见。
          </p>

          <figure class="figure_block figure_block--end">
            <img
              class="article_img"
              :src="images.img4"
              alt="座谈交流现场"
            >
            <figcaption class="figure_caption">座谈交流</figcaption>
          </figure>

          <p class="body_paragraph">
            此次区发改局领导的莅临指导，不仅是对我司过往工作的认可，更是对未来发展的有力鞭策。公司将以此为契机，继续坚持创新驱动发展战略，深耕新能源与软件赛道，不断提升核心竞争力，为区域经济的高质量发展贡献更多力量。
          </p>
        </div>
      </article>
    </div>

    <div class="news_detail_page_foot">
      <CallMe/>
      <MobileCallme/>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/report_list/SpaNav.vue'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
  },
  data () {
    return {
      images: {
        img1: require('@/assets/images/news-list/news2/image1.jpg'),
        img2: require('@/assets/images/news-list/news2/image2.jpg'),
        img3: require('@/assets/images/news-list/news2/image3.jpg'),
        img4: require('@/assets/images/news-list/news2/image4.jpg'),
      },
    }
  },
}
</script>

<style lang="scss">
@import '~@/assets/styles/news-detail-responsive.scss';
</style>
